import { t } from "@/i18n-js/instance";
import { OverviewStatComponent } from "@/react/components/Analytics/components/OverviewStatComponent";
import { i18nRoot } from "../../constants";
import {
  useVideoAnalyticsAverageProgress,
  useVideoAnalyticsUniqueViewers,
  useVideoAnalyticsViews,
} from "../hooks/useVideoAnalytics";

interface MetricsOverviewProps {
  endDate?: string;
  signedId: string;
  startDate?: string;
}

export const MetricsOverview = ({
  signedId,
  startDate,
  endDate,
}: MetricsOverviewProps) => {
  const { data: views, isLoading: isLoadingViews } = useVideoAnalyticsViews({
    signedId,
    startDate,
    endDate,
  });

  const { data: uniqueViewers, isLoading: isLoadingUniqueViewers } =
    useVideoAnalyticsUniqueViewers({
      signedId,
      startDate,
      endDate,
    });

  const { data: averageProgress, isLoading: isLoadingAverageProgress } =
    useVideoAnalyticsAverageProgress({
      signedId,
      startDate,
      endDate,
    });

  return (
    <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-3">
      <OverviewStatComponent
        title={t([i18nRoot, "analytics.metrics.views.title"])}
        value={views ?? 0}
        tooltip={t([i18nRoot, "analytics.metrics.views.tooltip"])}
        className="w-full"
        isLoading={isLoadingViews}
      />
      <OverviewStatComponent
        title={t([i18nRoot, "analytics.metrics.unique_viewers.title"])}
        value={uniqueViewers ?? 0}
        tooltip={t([i18nRoot, "analytics.metrics.unique_viewers.tooltip"])}
        className="w-full"
        isLoading={isLoadingUniqueViewers}
      />
      <OverviewStatComponent
        title={t([i18nRoot, "analytics.metrics.average_progress.title"])}
        value={averageProgress ?? 0}
        suffix="%"
        tooltip={t([i18nRoot, "analytics.metrics.average_progress.tooltip"])}
        className="w-full"
        isLoading={isLoadingAverageProgress}
      />
    </div>
  );
};
